export const uploadResourceType = 'file_info';
